<template>
<div class="chapter">
<div class="inner_page">
<div class="figcenter1" id="i02">
<img alt="" class="w" id="id-9062405258231834750" src="Images/img0001.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?0cc2d964